import { Component, HostListener, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { CommonService } from '../../services/common.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SystemRole } from '../../variables/constant';
import { CustomerService } from 'src/app/services/customer.service';

const logout = async (authService: AuthService): Promise<String> => {

  let response = await authService.logoutCustomer()
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      return response["message"]
    }

    return "";
  }

}

const validateSession = async (authService: AuthService, src: string): Promise<String> => {

  let response = await authService.validateSession(src)
    .toPromise()
    .catch(error => {
      if (error instanceof Object) {
        if (error["message"] != "") {
          alert(error["message"]);
        }
      }
      console.log(error);
    });
  if (response instanceof Object) {
    if (response["message"] != "" && response["message"] != undefined) {
      return response["message"]
    }

    return "";
  }

}
@Component({
  selector: 'app-customer-layout',
  templateUrl: './customer-layout.component.html',
  styleUrls: ['./customer-layout.component.scss']
})
export class CustomerLayoutComponent implements OnInit {
  public companylogo: string = "./assets/img/bertelsmann.png";
  currentYear: Date = new Date();
  
  constructor(private location: Location,
    public authService: AuthService,
    public commonService: CommonService,
    private customerService: CustomerService,
    public router: Router) {

      this.commonService.companyLogo.subscribe((res)=>{
        this.companylogo = res;
      })
    
    if (router.url != "/eCert") {
      if (this.authService.userRole$ != SystemRole.CUSTOMER || this.authService.currentUserValue == null) {
        this.router.navigate(['/eCert']);
      }        
    }
  }

  ngOnInit(): void {
    this.getUserDetails();
  }

  // Accessibility: Alt+1 jumps to navigation, Alt+2 jumps to main content.
  @HostListener('document:keydown', ['$event'])
  handleLandmarkShortcut(event: KeyboardEvent) {
    if (!event.altKey || (event.key !== '1' && event.key !== '2')) {
      return;
    }
    const targetId = event.key === '1' ? 'navbar-main' : 'main-content';
    const target = document.getElementById(targetId);
    if (target) {
      event.preventDefault();
      target.focus();
    }
  }

  // True while the customer is on the mandatory first-login password reset
  // screen (?resetPassword=true). Navigation to other areas of the portal is
  // blocked from the nav dropdown until the reset is complete.
  isFirstLoginResetFlow(): boolean {
    return this.router.url.includes('resetPassword=true');
  }

  logout() {
    logout(this.authService).then(data => {
      if (data == "Logged out successfully") {
        sessionStorage.clear();
        this.authService.logout();
        this.router.navigate(['/eCert']);
      }
    });
  }

  checksession() {
    validateSession(this.authService, "eCert").then(data => {
      if (data == "Session expired. Please login again.") {
        sessionStorage.clear();
        this.authService.logout();
        this.router.navigate(['/eCert']);
      }
    });
  }

  getUserDetails(){
    this.customerService.getCurrentMasterCustomer().subscribe((res: any) => {
      console.log("res",res);
      if(res && res['customerName']){
        this.authService.updateUserName(res['customerName']);
      }
    })
  }
}
